'use client';

import { useTranslations } from 'next-intl';
import { useEffect } from 'react';

import { Typography } from '@/components/atoms';
import { LinkButton } from '@/components/molecules';
import { logger } from '@/lib/logger';

interface ErrorPageProps {
  error: Error & { digest?: string };
  reset: () => void;
}

export default function ErrorPage({ error }: ErrorPageProps) {
  const t = useTranslations();

  useEffect(() => {
    logger.error(error, {
      source: 'nextjs-app-error.tsx',
      digest: error.digest,
    });
  }, [error]);

  return (
    <main className="min-h-screen flex flex-col items-center justify-center px-4 py-8 sm:py-12 md:py-16">
      <div className="w-full max-w-md">
        <Typography.Heading
          variant="h1"
          className="text-(--color-text-tertiary) not-italic! font-(family-name:--font-headings) text-(length:--text-h1) font-(--font-weight-h1) mb-0"
        >
          {t('B2B_ERROR_HEADING')}
        </Typography.Heading>
        <Typography.Heading
          variant="h4"
          className=" font-(--font-weight-h4) not-italic! text-(length:--text-h4)"
        >
          {t('B2B_ERROR_TITLE')}
        </Typography.Heading>
        <Typography.Text
          variant="paragraph"
          className="font-(--font-weight-body-2xl) not-italic! text-(length:--text-body-2xl) -mt-4"
        >
          {t('B2B_ERROR_DESCRIPTION')}
        </Typography.Text>
        <div className="flex items-center">
          <LinkButton
            href="/"
            variant="primary"
            className="w-full mt-10 border border-(--button-secondary-border-color-active) rounded-(--button-secondary-radius-default) text-(length:--text-button-lg) font-(--font-weight-button-md)"
          >
            {t('GO_BACK_HOME_PAGE')}
          </LinkButton>
        </div>
      </div>
    </main>
  );
}
